import type { UndefinedInitialDataOptions, UseQueryOptions } from '@tanstack/react-query';

/**
 * Partial type for overriding query options
 * use UndefinedInitialDataOptions to allow undefined initial data
 */
export type QueryOptionsOverride<TQueryFnData = unknown, TError = Error, TData = TQueryFnData>
  = Omit<
    Partial<UndefinedInitialDataOptions<TQueryFnData, TError, TData>>,
    'queryKey' | 'queryFn'
  >;

export type QueryBehaviorOptions<TQueryFnData, TData = TQueryFnData> = Pick<
  UseQueryOptions<TQueryFnData, Error, TData>,
  | 'enabled'
  | 'select'
  | 'staleTime'
  | 'gcTime'
  | 'refetchOnWindowFocus'
>;

export const PUBLIC_QUERY_STALE_TIME = Infinity;
